
<template>
  <div class="page" ref="pageRef">
    <div class="page_top_bg">
      <img
        src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741936098056/project_top_bg.png"
      />
    </div>
    <div class="page_wrap">
      <div class="performance_tab">
        <div
          class="tab_item"
          :class="tabIndex == 1 ? 'tab_active' : ''"
          @click="handleChangeTab(1)"
        >
          造价业绩
        </div>
        <div
          class="tab_item"
          :class="tabIndex == 2 ? 'tab_active' : ''"
          @click="handleChangeTab(2)"
        >
          监理业绩
        </div>
        <div
          class="tab_item"
          :class="tabIndex == 3 ? 'tab_active' : ''"
          @click="handleChangeTab(3)"
        >
          招标代理业绩
        </div>
      </div>
      <div class="performance_table">
        <div class="performance_box">
          <div
            class="performance_item"
            v-for="(item, index) in List"
            :key="index"
            @click="handleRouter(item)"
          >
            <div class="item_pic">
              <img :src="item.pic" alt="" />
            </div>
            <div class="item_content">
              <div class="title">{{ item.name }}</div>
              <div class="tag">
                <div class="tag_label">{{ item.attr }}</div>
                <div class="tag_label">{{ item.money }}</div>
              </div>
              <div class="time">{{ item.time }}</div>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: center; margin-top: 40px">
          <NPagination
            v-model:page="page"
            v-model:page-size="pageSize"
            :item-count="total"
            :on-update:page="handlePageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import axios from "axios";
import { NPagination } from "naive-ui";
import qs from "qs";
import {
  defineComponent,
  getCurrentInstance,
  h,
  onMounted,
  reactive,
  ref,
  toRefs,
  watchEffect,
} from "vue";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  components: {
    NPagination,
  },
  setup() {
    const { proxy } = getCurrentInstance() as any;
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      tabIndex: 1 as any,
      List: [] as any,
      page: 1 as any,
      pageSize: 10 as any,
      total: 0,
    });
    onMounted(() => {
      sessionStorage.clear()
      getList(state.tabIndex);
    });

    // 页码改变时的处理函数
    const handlePageChange = (newPage: any) => {
      state.page = newPage;
    };

    const handleChangeTab = (val: any) => {
      state.page = 1;
      state.tabIndex = val;
      getList(state.tabIndex);
      sessionStorage.clear()
    };

    const pageRef = ref();
    const scrollToTop = () => {
      if (pageRef.value) {
        pageRef.value.scrollIntoView({ behavior: "smooth" });
      }
    };
    const getList = async (type: any) => {
      try {
        let params = {
          type: type,
          page: state.page,
          pageSize: state.pageSize,
          status: 1,
        };
        const url = `/api/t_show_content/page?${qs.stringify(params)}`; // 通过代理路径访问
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP Error! 状态码: ${response.status}`);
        }

        const data = await response.json();
        state.List = data.data.records;
        state.total = data.data.total;
      } catch (error) {
        console.error("请求失败:", error);
      }
    };
    const handleRouter = (row: any) => {
      let data = {
        type: state.tabIndex,
        page: state.page,
        pageSize: state.pageSize,
      };
      sessionStorage.setItem("info", qs.stringify(data));
      router.push({
        path: "projectInfo",
        query: {
          id: row.id,
        },
      });
    };
    watchEffect(() => {
      let info = sessionStorage.getItem("info");
      if (info) {
        let data = qs.parse(info);
        state.page = data.page;
        state.pageSize = data.pageSize;
        state.tabIndex = data.type;
        getList(state.tabIndex);
      }
      if (route.query.type) {
        handleChangeTab(route.query.type);

        setTimeout(() => {
          scrollToTop();
        }, 0);
      }
    });
    return {
      handleRouter,
      handlePageChange,
      handleChangeTab,
      pageRef,
      ...toRefs(state),
    };
  },
});
</script>
<style scoped lang="scss">
.page {
  padding-bottom: 64px;
  .page_top_bg {
    width: 100%;
    height: 426px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 426px;
      object-fit: cover;
    }
  }
  .page_wrap {
    width: 1200px;
    margin: 0px auto 0px;
    position: relative;
    z-index: 10;
    border-radius: 16px;
    padding: 40px 0px;
    .performance_tab {
      display: flex;
      justify-content: center;
      .tab_item {
        margin: 0 12px;
        width: 160px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        cursor: pointer;

        font-weight: 600;
        font-size: 16px;
        color: #333333;
      }
      .tab_active {
        border-bottom: 2px solid #377dca;
        color: #377dca;
      }
    }
    .performance_table {
      .performance_box {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .performance_item {
          margin-top: 32px;
          width: calc(50% - 16px);
          background: #ffffff;
          border-radius: 8px;
          overflow: hidden;
          display: flex;
          cursor: pointer;
          .item_pic {
            width: calc(100% - 304px);
            height: 162px;
            img {
              width: 100%;
              height: 162px;
              object-fit: cover;
            }
          }
          .item_content {
            width: 304px;
            padding: 16px;
            .title {
              width: 100%;
              height: 72px;
              font-weight: bold;
              font-size: 16px;
              color: #000000;
              line-height: 24px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3; //多行在这里修改数字即可
              overflow: hidden;
              -webkit-box-orient: vertical;
            }
            .tag {
              margin: 8px 0px 14px;
              display: flex;
              .tag_label:nth-of-type(1) {
                height: 24px;
                background: rgba(82, 55, 202, 0.17);
                border-radius: 4px;
                font-size: 14px;
                color: #000000;
                text-align: center;
                line-height: 24px;
                padding: 0px 8px;
              }
              .tag_label:nth-of-type(2) {
                margin-left: 8px;
                height: 24px;
                background: rgba(202, 134, 55, 0.17);
                border-radius: 4px;
                font-size: 14px;
                color: #000000;
                text-align: center;
                line-height: 24px;
                padding: 0px 8px;
              }
            }
            .time {
              font-size: 12px;
              color: rgba(0, 0, 0, 0.3);
            }
          }
        }
      }
    }
  }
}
</style>
  